import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { Order } from 'depoto-core/src/entities'
import { CoreService } from '../../../services'

@Component({
  selector: 'app-order-bill-vat',
  templateUrl: './order-bill-vat.component.html',
  styleUrls: ['order-bill-vat.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OrderBillVatComponent {
  @Input() order: Order

  constructor(protected core: CoreService) {}
}
